<div id="div-header" *ngIf="headerService.visible">
    <app-header *ngIf="headerService.header == enumHeader.Sbm"></app-header>
    <app-dms-header *ngIf="headerService.header == enumHeader.Dms"></app-dms-header>
</div>

<div id="div-wrapper-route" [ngClass]="{'headerVisible': headerService.visible, 'headerNotVisible': !headerService.visible}" *ngIf="initialized">
    <router-outlet></router-outlet>
</div>

<ngx-spinner bdColor="rgba(255, 255, 255, 0.5)" size="medium" [color]="color" type="ball-clip-rotate"></ngx-spinner> <!-- nuovo web bdColor="rgba(0, 0, 0, 0.2)" -->

<button class="scroll-to-top-button" mat-mini-fab (click)="containerService.scrollToTop()" [ngStyle]="{'background-color': color}" [hidden]="!scrollToTopVisible" *ngIf="showScrollToTopButton">
    <i class="material-icons">keyboard_arrow_up</i>
</button>

<ng-container *ngIf="containerService.messages != null && containerService.messages.length > 0">
    <div class="messages-container position-absolute">
        <div class="message-box mb-2 ml-2 pr-3 pl-3 pt-4 pb-4 mat-elevation-z5 position-relative font-weight-bold" *ngFor="let messaggio of containerService.messages; let i = index;">
            <button mat-icon-button class="position-absolute hide-message-button" (click)="containerService.messages.splice(i, 1)"><span class="material-icons hide-message-icon">clear</span></button>
            <app-inner-html [text]="messaggio"></app-inner-html>
        </div>
    </div>
</ng-container>